import {AbstractFormArgument} from '../global'

class QueArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.contacts = ''
    this.mobile = ''
    this.itemName = ''
    this.webSite = ''
    this.regtime = ''
    this.brands = ''
    this.popularizeTimeSpan = ''
    this.vitalArea = ''
    this.cooperantShop = ''
    this.productOrientation = ''
    this.products = ''
    this.mainKeywords = ''
    this.emphasisKeywords = ''
    this.mainArea = ''
    this.notArea = ''
    this.popularizeTime = ''
    this.dailyBudget = ''
    this.genderRation = ''
    this.ageSegment = ''
    this.filiale = ''
    this.filialeCitys = ''
    this.joinWebSite = ''
    this.advantage = ''
    this.minInvestment = ''
    this.maxInvestment = ''
    this.joinPolicy = ''
    this.competitor = ''
    this.tvCompetitor = ''
    this.teamPeople = ''
    this.dailyMinResource = ''
    this.onlineService = ''
    this.contacts = ''
    this.qq = ''
    this.mobile = ''
    this.visitingRate = ''
    this.closeRate = ''
  }
}

export {
  QueArgument
}



// WEBPACK FOOTER //
// ./src/models/tourist/questionnaire.js